module.exports = __webpack_public_path__ + "img/maisonette-4.4fc5572a.webp";